import React from 'react'
import { Row, Col } from 'react-flexbox-grid'
import Config from '../../Config'
import Card from '@material-ui/core/Card'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { push } from 'connected-react-router'
import Divider from '@material-ui/core/Divider'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import Drawer from '@material-ui/core/Drawer'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'

import ClaimExpenseLine from '../../widgets/SubmitAClaim/ClaimExpenseLine'
import ManageExpense from '../../widgets/SubmitAClaim/ManageExpense'
import ManageDentalExpense from '../../widgets/SubmitAClaim/ManageDentalExpense'
import ManageDrugExpense from '../../widgets/SubmitAClaim/ManageDrugExpense'
import DrugClaimExpenseLine from '../../widgets/SubmitAClaim/DrugClaimExpenseLine'
import { localize, getLocale } from '../../util/Localizer'
import { formatCurrency } from '../../util/CurrencyFormatter'
import Loading from '../../widgets/Loading'
import RBButton from '../../controls/RBButton'
import HCSAPopupMessage from '../../util/ui/HCSAPopupMessage'

import { updateClaim, getMvaTypes } from '../../redux/actions/submitAClaimActions'
import { ClaimTypes } from '../../redux/SubmitClaim/Common'
import { passMessage, clearNavDialog, goNext, passNavCallbacks } from '../../redux/actions/submitNavigationActions'
import DentalClaimExpenseLine from '../../widgets/SubmitAClaim/DentalClaimExpenseLine'
import extractServiceItems from '../../util/ExtractServiceItems'
import NgrxUtils from '../../util/NgrxUtils'

class ClaimExpenses extends React.Component {
  constructor (props) {
    super(props)
    this.addEditClaimExpense = this.addEditClaimExpense.bind(this)
    this.showEditForm = this.showEditForm.bind(this)
    this.deleteClaimExpense = this.deleteClaimExpense.bind(this)
    this.updateNext = this.updateNext.bind(this)
    this.hideManageExpense = this.hideManageExpense.bind(this)
    this.showManageExpense = this.showManageExpense.bind(this)
    this.updateTotal = this.updateTotal.bind(this)
    this.sendPopupMessage = this.sendPopupMessage.bind(this)
    this.mvaTypesPresent = this.mvaTypesPresent.bind(this)
    this.updateMva = this.updateMva.bind(this)
    this.state = {
      claimExpenses: [],
      claimExpenseToEdit: {},
      claimIndexToEdit: -1,
      totalPaid: 0,
      totalPaidByOther: 0,
      isHCSAChecked: false,
      isVerifiedChecked: false,
      open: false,
      shouldRenderManageExpense: false,
      screenWidth: window.innerWidth > 500 ? 490 : 300,
      MVARelated: null
    }
  }

  componentDidMount () {
    this.props.setNext(null)
    this.props.setPercent(70)
    this.props.adjustScrollBar()
    this.props.passNavCallbacks({})
    const { claimObj } = this.props
    this.props.getMvaTypes(claimObj)
    let claimExpenses = []

    switch (claimObj.type) {
      case ClaimTypes.DRUG:
      case ClaimTypes.DRUG_FR:
        claimExpenses = [...claimObj.DrugClaimLines]
        break
      case ClaimTypes.DENTAL:
      case ClaimTypes.DENTAL_FR:
        claimExpenses = [...claimObj.DentalClaimLines]
        break
      default:
        claimExpenses = [...claimObj.ExtendedHealthCareLines]
        break
    }

    this.setState({ claimExpenses })
    this.updateTotal(claimExpenses)
  }

  componentDidUpdate (prevProps) {
    const { dialogRsp } = this.props
    if ((dialogRsp !== prevProps.dialogRsp) && (dialogRsp === true || dialogRsp === false)) {
      this.props.goNext()
    }
  }

  sendPopupMessage () {
    if (this.props.memberSummary.healthCareSpendingAccountBalance > 0) {
      const message = HCSAPopupMessage({
        balance: this.props.memberSummary.healthCareSpendingAccountBalance
      })
      this.props.passMessage(message)
    }
  }

  // Add Expense
  addEditClaimExpense (claimExpense) {
    if (claimExpense) {
      if (claimExpense.ExtendedHealthCareLineInfo) {
        claimExpense.ExtendedHealthCareLineInfo.ServiceCodeText = claimExpense.ExtendedHealthCareLineInfo.ServiceCode.text
        claimExpense.ExtendedHealthCareLineInfo.ServiceCode = claimExpense.ExtendedHealthCareLineInfo.ServiceCode.id
      }
      const claimExpenses = [...this.state.claimExpenses]
      if (this.state.claimIndexToEdit === -1) {
        claimExpense.ClaimLineId = (claimExpenses.length || 0) + 1
        claimExpenses.push(claimExpense)
      } else {
        claimExpenses[this.state.claimIndexToEdit] = claimExpense
      }
      this.updateTotal(claimExpenses)
    }
  }

  mvaTypesPresent () {
    const { claimExpenses = [] } = this.state
    const { mvaTypes } = this.props
    const claimedServiceCodes = claimExpenses.map(expense => {
      const { ExtendedHealthCareLineInfo = {}, DentalInfo = {} } = expense
      if (!NgrxUtils.isEmpty(ExtendedHealthCareLineInfo)) {
        return ExtendedHealthCareLineInfo.ServiceCode
      } else if (!NgrxUtils.isEmpty(DentalInfo)) {
        return DentalInfo.ProcedureCode
      } else {
        return ''
      }
    })
    const matchingCodes = claimedServiceCodes.find(sc => mvaTypes.includes(sc))
    return matchingCodes !== undefined
  }

  updateMva (value) {
    const { claimObj = {} } = this.props
    // mva content is being moved to claim common on submission because it is
    // currently overwritten by the hcsa popup
    const nextClaimObj = {
      ...claimObj,
      MVARelated: value
    }
    this.props.updateClaim(nextClaimObj)
    this.setState({ MVARelated: value }, () => this.updateNext())
  }

  showEditForm (indx) {
    const claimExpense = Array.from([...this.state.claimExpenses])[indx]
    if (claimExpense) {
      this.setState({
        claimExpenseToEdit: claimExpense,
        claimIndexToEdit: indx,
        shouldRenderManageExpense: true
      }, () => {
        setTimeout(() => {
          this.setState({
            open: true
          })
        })
      })
    }
  }

  deleteClaimExpense (indx) {
    if (indx > -1) {
      const claimExpenses = [...this.state.claimExpenses]
      claimExpenses.splice(indx, 1)
      // Update claim line id
      claimExpenses.forEach((expense, indx) => {
        expense.ClaimLineId = indx + 1
      })
      this.updateTotal(claimExpenses)
    }
  }

  hideManageExpense () {
    this.setState({
      open: false
    }, () => {
      // NOTE: this is here so we can see the thing slide out :)
      setTimeout(() => {
        this.setState({
          shouldRenderManageExpense: false,
          claimExpenseToEdit: {},
          claimIndexToEdit: -1
        })
      }, 250)
    })
  }

  showManageExpense () {
    this.setState({
      shouldRenderManageExpense: true
    }, () => {
      setTimeout(() => {
        this.setState({
          open: true
        })
      })
    })
  }

  updateTotal (claimExpenses) {
    let totalPaidByOther = 0
    let totalPaid = 0
    const claimObj = { ...this.props.claimObj }
    switch (claimObj.type) {
      case ClaimTypes.DRUG:
      case ClaimTypes.DRUG_FR:
        claimObj.DrugClaimLines = claimExpenses
        claimObj.DrugClaimLines.forEach((e) => e.DrugInfo.Province = e.DrugInfo.Province.id || e.DrugInfo.Province) // eslint-disable-line
        totalPaid = claimExpenses.reduce((a, b) => { return a + Number(b.DrugInfo.DrugCost) + Number(b.DrugInfo.DispenseFee) }, 0)
        if (claimObj.cob) {
          totalPaidByOther = claimExpenses.reduce((a, b) => { return a + Number(b.COBField.COBAmount || 0) }, 0)
        }
        break
      case ClaimTypes.DENTAL:
      case ClaimTypes.DENTAL_FR:
        claimObj.DentalClaimLines = claimExpenses
        totalPaid = claimExpenses.reduce((a, b) => { return a + Number(b.DentalInfo.ProcedureFees) + Number(b.DentalInfo.LaboratoryFees) }, 0)
        if (claimObj.cob) {
          totalPaidByOther = claimExpenses.reduce((a, b) => { return a + Number(b.COBField.COBAmount || 0) }, 0)
        }
        break
      default:
        claimObj.ExtendedHealthCareLines = claimExpenses
        claimObj.ExtendedHealthCareLines.forEach((e) => e.ExtendedHealthCareLineInfo.AmountPaid = Number(e.ExtendedHealthCareLineInfo.AmountPaid))// eslint-disable-line
        totalPaid = claimExpenses.reduce((a, b) => { return a + Number(b.ExtendedHealthCareLineInfo.AmountPaid) }, 0)
        if (claimObj.cob) {
          totalPaidByOther = claimExpenses.reduce((a, b) => { return a + Number(b.COBField.CobAmount || 0) }, 0)
        }
        break
    }

    // set the claim object total amount
    claimObj.TotalAmount = totalPaid

    // update the state
    this.setState({
      claimExpenses,
      totalPaid: claimObj.TotalAmount,
      totalPaidByOther
    }, () => this.updateNext())
    this.props.updateClaim(claimObj)
  }

  updateNext () {
    const { isVerifiedChecked, claimExpenses } = this.state
    const { MVARelated = null } = this.props.claimObj
    const mvaExpensesClaimed = this.mvaTypesPresent()
    const mvaRequired = Config.showMvaQuestion && mvaExpensesClaimed
    const mvaChecked = (MVARelated === 'true' || MVARelated === 'false')
    if (isVerifiedChecked === true && claimExpenses.length > 0 && (mvaRequired ? mvaChecked : true)) {
      this.props.setNext('certifcationAndAuthorization')
      this.sendPopupMessage()
    } else {
      this.props.passMessage(undefined)
      this.props.setNext(null)
    }
  }

  render () {
    return (
      <Card className='submitCard'>
        <Row>
          <Col xs={12}>
            <Row>
              <Col xs={12} md={8} sm={8} lg={9}>
                <Row start='xs'>
                  <Col xs={12}>
                    <h3>
                      {localize('pages.SubmitAClaim.UnpaidExpenses.Title')}
                    </h3>
                    <Row middle='xs'>
                      <p className='titledLabelTitle' style={{ textAlign: 'left', margin: '0px 5px 0px 9px' }}>{localize('pages.SubmitAClaim.Patient')}: </p>
                      <p style={{ textAlign: 'left', margin: 0 }}>{this.props.claimObj.Patient}</p>
                    </Row>
                  </Col>
                </Row>
              </Col>
              <Col xs={12} md={4} sm={4} lg={3} className='addClaimExpenseBtn'>
                <Row start='xs' end='sm'>
                  <Col xs={12}>
                    <RBButton
                      id='addClaimExpenseBtn'
                      className='submitNavButton'
                      label={localize('pages.SubmitAClaim.Expenses.AddExpenseButton')}
                      disabled={this.state.claimExpenses.length > 6}
                      onClick={this.showManageExpense}
                      primary
                      variant='contained'
                    />
                  </Col>
                </Row>

              </Col>
              {this.renderBody()}
            </Row>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            {this.state.shouldRenderManageExpense ? <Drawer
              anchor="right"
              open={this.state.open}
              PaperProps={{ style: { width: this.state.screenWidth } }}
            >
              {this.props.claimObj && ClaimTypes.isDental(this.props.claimObj.type) &&
                <ManageDentalExpense hasCOB={this.props.hasCOB}
                  onAddExpense={this.addEditClaimExpense}
                  onCancel={this.hideManageExpense}
                  claimExpense={this.state.claimExpenseToEdit}
                  claimIndx={this.state.claimIndexToEdit} />}
              {this.props.claimObj &&
                ClaimTypes.isDental(this.props.claimObj.type) !== true && ClaimTypes.isDrug(this.props.claimObj.type) !== true &&
                <ManageExpense hasCOB={this.props.hasCOB}
                  onAddExpense={this.addEditClaimExpense}
                  onCancel={this.hideManageExpense}
                  claimExpense={this.state.claimExpenseToEdit}
                  claimIndx={this.state.claimIndexToEdit}
                  serviceItems={this.props.serviceItems} />}
              {this.props.claimObj &&
                ClaimTypes.isDrug(this.props.claimObj.type) &&
                <ManageDrugExpense hasCOB={this.props.hasCOB}
                  onAddExpense={this.addEditClaimExpense}
                  onCancel={this.hideManageExpense}
                  claimExpense={this.state.claimExpenseToEdit}
                  claimIndx={this.state.claimIndexToEdit} />}
            </Drawer> : null}
          </Col>
        </Row>
      </Card>
    )
  }

  renderBody () {
    if (this.state.claimExpenses.length > 0) {
      const loc = getLocale()
      const { appContent = {}, claimObj = {} } = this.props
      const { contentItemText = {} } = appContent
      const { content = '' } = contentItemText[loc] || {}
      const mvaExpensesClaimed = this.mvaTypesPresent()
      return (
        <div style={{ width: '100%' }}> {/* width added for IE */}
          <Row>
            <Col><p className='titledLabelLabel' style={{ fontSize: '0.97rem', marginLeft: '10px' }}>{localize('pages.SubmitAClaim.Expenses.MaximumOf7LinesText')}</p></Col>
          </Row>
          <Row>
            <Col xs={12}>
              {this.renderExpenses()}
            </Col>
          </Row>
          <Row>
            <Col xs={12} />
          </Row>
          <br />
          <Row>
            <Col xs={12}>
              <Divider />
            </Col>
          </Row>
          <br />
          { mvaExpensesClaimed && Config.showMvaQuestion && <Row>
            <Col xs={12}>
              <p>{localize('pages.SubmitAClaim.Expenses.mvaRelatedLabel')}</p>
              <RadioGroup
                aria-label={localize('pages.SubmitAClaim.Expenses.mvaRelatedLabel')}
                value={claimObj.MVARelated}
                onChange={(e, v) => this.updateMva(v)}
              >
                <FormControlLabel
                  value={'true'}
                  control={<Radio color={'primary'} />}
                  label={localize('pages.SubmitAClaim.Expenses.mvaRelatedYes')}
                />
                <FormControlLabel
                  value={'false'}
                  control={<Radio color={'primary'} />}
                  label={localize('pages.SubmitAClaim.Expenses.mvaRelatedNo')}
                />
                <p className='mvaNoText'>{localize('pages.SubmitAClaim.Expenses.mvaRelatedNoText')}</p>
              </RadioGroup>
            </Col>
          </Row> }
          <br/>
          <Row>
            <Col xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.checkedA}
                    onChange={(e, v) => this.setState({ isVerifiedChecked: v }, () => this.updateNext())}
                    value={'true'}
                    color='primary'
                  />
                }
                label={content}
              />
            </Col>
          </Row>
        </div>
      )
    } else {
      const addExpenseText = localize('pages.SubmitAClaim.Expenses.NoExpenses')
      return (
        <p>{addExpenseText}</p>
      )
    }
  }

  renderLoading () {
    return (
      <Row start='xs'>
        <Col xs={12}>
          <Loading message={localize('common.loadingContent')} />
        </Col>
      </Row>
    )
  }

  renderDentalExpenses () {
    if (this.props.claimObj && ClaimTypes.isDental(this.props.claimObj.type)) {
      return (
        Array.from(this.state.claimExpenses)
          .map((expense, key) => <DentalClaimExpenseLine key={key} index={key}
            onEdit={this.showEditForm}
            onDelete={this.deleteClaimExpense}
            expenseDetail={expense}
            hasCOB={this.props.hasCOB}
          />)
      )
    }
  }

  renderEHCExpenses () {
    if (this.props.claimObj && ClaimTypes.isDental(this.props.claimObj.type) !== true && ClaimTypes.isDrug(this.props.claimObj.type) !== true) {
      let allExp = Object.assign([], this.state.claimExpenses, this.props.claimObj.ExtendedHealthCareLines
      )
      return (
        Array.from(allExp)
          .map((expense, key) => <ClaimExpenseLine key={key} index={key}
            onEdit={this.showEditForm}
            onDelete={this.deleteClaimExpense}
            expenseDetail={expense}
            hasCOB={this.props.hasCOB}
          />)
      )
    }
  }
  renderDrugExpenses () {
    if (this.props.claimObj && ClaimTypes.isDrug(this.props.claimObj.type)) {
      return (
        Array.from(this.state.claimExpenses)
          .map((expense, key) => <DrugClaimExpenseLine key={key} index={key}
            onEdit={this.showEditForm}
            onDelete={this.deleteClaimExpense}
            expenseDetail={expense}
            hasCOB={this.props.hasCOB}
          />)
      )
    }
  }

  renderExpenses () {
    const totalLabelProps = this.props.hasCOB ? { xs: 3, sm: 6, lg: 4 } : { xs: 6, sm: 8, lg: 5 }
    const totalValProps = this.props.hasCOB ? { xs: 9, sm: 6, lg: 2 } : { xs: 6, sm: 8, lg: 5 }
    const totalOtherValProps = this.props.hasCOB ? { xs: 12, sm: 12, lg: 2 } : null
    return (
      <div>
        <Row>
          <Col xs={12}>
            {this.renderEHCExpenses()}
            {this.renderDentalExpenses()}
            {this.renderDrugExpenses()}
          </Col>
        </Row>
        {this.state.claimExpenses.length > 0
          ? <Row>
            <Col {...totalLabelProps}>
              <Row end='sm' start='xs'>
                <Col xs={12}>
                  <span className='titledLabelLabel claimid'>{localize('pages.SubmitAClaim.Expenses.Total')}</span>
                </Col>
              </Row>
            </Col>
            <Col {...totalValProps}>
              <span className='titledLabelLabel claimid'>{formatCurrency(this.state.totalPaid || 0)}</span>
            </Col>
            {this.props.hasCOB
              ? <Col {...totalOtherValProps}>
                <Row>
                  <Col xsOffset={3} xs={9} smOffset={6} lgOffset={0}>
                    <span className='titledLabelLabel claimid'>{formatCurrency(this.state.totalPaidByOther || 0)}</span>
                  </Col>
                </Row>
              </Col>
              : null
            }
          </Row>
          : null
        }
      </div>)
  }
}

function mapStateToProps (state) {
  const claimObj = state.SubmitAClaimReducer.claimObj || {}
  const { benefitTypes = [] } = state.SubmitExpenseReducer.benefitTypes || {}

  const serviceItems = extractServiceItems(claimObj, benefitTypes).map((item) => ({
    id: item.serviceCode,
    text: item.name
  }))
  // const mavTypes = state.mavTypes

  return {
    claimObj,
    serviceItems,
    memberSummary: state.memberSummaryReducer.memberSummary,
    hasCOB: state.SubmitAClaimReducer.claimObj && state.SubmitAClaimReducer.claimObj.cob,
    dialogRsp: state.SubmitNavigationReducer.dialogRsp,
    mvaTypes: state.SubmitAClaimReducer.mvaTypes
  }
}
const ConnectedClaimExpenses = connect(mapStateToProps, {
  push,
  updateClaim,
  passMessage,
  clearNavDialog,
  goNext,
  passNavCallbacks,
  getMvaTypes
})(injectIntl(ClaimExpenses))

export default ConnectedClaimExpenses



// WEBPACK FOOTER //
// ./src/components/SubmitAClaim/ClaimExpenses.js